// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"bA-z","giftOrPromoSelector":"cA-z","disabled":"dA-z","subTitle":"eA-z","selectShipAddressMessage":"fA-z","changePayment":"gA-z"};